<template>
  <div v-if="blok" v-html="blok?.fields.htmlContentTwo"></div>
</template>

<script setup lang="ts">
import type { CMSHtmlComponentProps } from '../types'

const { blok } = defineProps<CMSHtmlComponentProps>()
</script>
